import { render } from "./App.vue?vue&type=template&id=5e105aba"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5e105aba&lang=less"
script.render = render

export default script